// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uPAy","label":"styles_label__3NyB7"};